import { Component, inject, OnInit,signal,Signal,ViewChild } from '@angular/core';

import { Form, UntypedFormArray, UntypedFormBuilder,UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_LOCALE, MatOptionModule} from '@angular/material/core';
import {MatDatepickerIntl, MatDatepickerModule} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { FlowItemModel } from '../../models/FlowItemModel';
import { ScoutingFlowService } from '../../services/scouting-flow.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ScoutingPlayerService } from '../../services/scouting-player.service';

import { TestResultKPIViewModel } from 'src/app/shared/models/test.model';
import { NoteCardComponent } from '../../components/note-card/note-card.component';
import { ReportCardComponent } from '../../components/report-card/report-card.component';
import { ReportSearchResultOverviewComponent } from "../../components/report-search-result-overview/report-search-result-overview.component";
import { ScoutingSearchResultOverview } from '../../models/ScoutingSearchResultOverview';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';



@Component({
    selector: 'app-filtered-scouting-flow',
    providers: [
        // The locale would typically be provided on the root module of your application. We do it at
        // the component level here, due to limitations of our example generation script.
        { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
        // Moment can be provided globally to your app by adding `provideMomentDateAdapter`
        // to your app config. We provide it at the component level here, due to limitations
        // of our example generation script.
        provideMomentDateAdapter()
    ],
    templateUrl: './filtered-scouting-flow.component.html',
    styleUrl: './filtered-scouting-flow.component.css',
    imports: [ReactiveFormsModule, ReportCardComponent, NoteCardComponent, ReportSearchResultOverviewComponent, MatSelectModule, MatDividerModule, MatFormFieldModule, MatFormField, MatProgressBarModule, MatDatepickerModule, MatOptionModule, MatButtonModule, MatInputModule]
})




export class FilteredScoutingFlowComponent implements OnInit {
  _flowitems: FlowItemModel[];
  public isBusy = signal(true);
  reportMasterdata: any;
  availableBirthYears: number[];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  searchForm: FormGroup;


  /* searchForm = new UntypedFormGroup({
    PlayerFirstName: new UntypedFormControl(''),
    PlayerLastName: new UntypedFormControl(''),
    PositionIds: new UntypedFormControl(''),
    YearsOfBirth: new UntypedFormControl(''),
    ShootIds: new UntypedFormControl(''),
    Projections: new UntypedFormControl(''),
    PlayerTypes: new UntypedFormControl(''),
    Capacities: new UntypedFormControl(''),
    MaxHits: new UntypedFormControl('100'),
    minReportDate:new UntypedFormControl(''),
    maxReportDate:new UntypedFormControl(''), 
    ScoutingSources: new UntypedFormControl('')
  }); */
  SearchResultOverview: ScoutingSearchResultOverview;


  

  constructor(public flowService: ScoutingFlowService,public scoutingRep: ScoutingPlayerService, public matDialog: MatDialog,   private _formBuilder: UntypedFormBuilder,) {

   
   }

  ngOnInit() {

    this.isBusy.set(true);
    //Set the search from date
    var d: Date = new Date();    
    d.setMonth(d.getMonth() - 3);
    d.setHours(0, 0, 0, 0);

    
  this.searchForm = this._formBuilder.group({
    PlayerFirstName: '',
    PlayerLastName: '',
    PositionIds: '',
    YearsOfBirth: '',
    ShootIds: '',
    Projections: '',
    PlayerTypes: '',
    Capacities: '',
    MaxHits: 100,
    minReportDate:d,
    maxReportDate:'', 
    ScoutingSources: ''
  });
  /*this.searchForm = this._formBuilder.group({
      PlayerFirstName: '',
      PlayerLastName: '',
      PositionIds: '',
      YearsOfBirth: '',
      ShootIds: '',
      Projections: '',
      PlayerTypes: '',
      Capacities: '',
      MaxHits: 100,
      minReportDate:'',
      maxReportDate:'', 
      ScoutingSources: ''
    }); */

this.scoutingRep.getReportSearchMasterDataForOrg().subscribe(data =>{
       console.log('getreportmasterdata');
      //console.log(this.searchForm.value);
      this.reportMasterdata = data;
      
    }); 
    //this.searchForm.controls['minReportDate'].setValue(d);

    var earliestYear = new Date().getFullYear() - 13;

    this.availableBirthYears =
    Array.from(
      { length: 45 },
      (value, index) => earliestYear - index 
      );
      //console.log("availableBirthYears");
      //console.log(this.availableBirthYears);

      console.log(this.searchForm.value);
     this.scoutingRep.getScoutingSearchResultOverview(this.searchForm.value).subscribe(overview =>{
      this.SearchResultOverview = overview;
    });
    
    this.scoutingRep.getFlow(this.searchForm.value).subscribe(r=> {

      this._flowitems = r;
      this.isBusy.set(false);
    }); 
  }

  //Function to increase performance of long lists
  trackByFn(index, flowitem) {
    if(flowitem.FlowItemType=='PLAYERNOTE')
      return flowitem.PlayerNoteId;
    else
      return flowitem.ReportId; // Use the 'id' property as the unique identifier
  }

  loadFlow(){
    this.isBusy.set(true);

    try {
      //Clear result

      var p = this.searchForm.value;

      //console.log(p);
   
      this._flowitems = null;

      this.scoutingRep.getScoutingSearchResultOverview(this.searchForm.value).subscribe(overview =>{
        this.SearchResultOverview = overview;
      });

      this.scoutingRep.getFlowReports(this.searchForm.value).subscribe( result=>{
          //console.log("loadFlow");
          
          this._flowitems = result;
          this.isBusy.set(false);
          
      }); 
    } catch (error) {
      this.isBusy.set(false);
    }
    finally{
      //this.isBusy.set(false);
    }

  }

  
}